import { AppBar, Button, Dialog, Grid, Toolbar, Typography } from "@mui/material"
import { useListaCidadesService } from "../../../../../../../../../use-cases/geo-veles"
import { useAppSelector } from "../../../../../../../../hooks/store-hooks"
import { Transition } from "../../../../../../../../components"
import { FileUpload } from "./FileUpload"
import { PreviewListaCidades } from "./PreviewListaCidades"

export const ListaCidadesImportFile = (props: {
    openImportFile: boolean
}) => {
    // State
    const { listaCidades } = useAppSelector((state) => state)
    // Hook
    const {
        openImportFileListaCidades,
        resetListaCidadesFileData
    } = useListaCidadesService()

    return (
        <>
            <Dialog
                fullWidth
                maxWidth="xl"
                open={listaCidades.openImportFileListaCidades}
                TransitionComponent={Transition}
                onClose={() => {
                    openImportFileListaCidades(false)
                    resetListaCidadesFileData()
                }}
            >
                <AppBar sx={{ position: 'relative' }}>
                    <Toolbar>
                        <Typography sx={{ ml: 2, flex: 1 }} textTransform="uppercase" variant="h6" component="div">
                            Importar arquivo de lista de Cidades
                        </Typography>
                        <Button
                            autoFocus
                            color="inherit"
                            onClick={() => {
                                openImportFileListaCidades(false)
                            }}
                        >
                            Fechar
                        </Button>
                    </Toolbar>
                </AppBar>
                <Grid container spacing={3} sx={{ p: 3 }}>
                    <Grid item xs={12}>
                        {/* Drag and drop component*/}
                        <FileUpload label={"Clique aqui ou arraste e solte o arquivo aqui para definir a lista"} />
                    </Grid>
                </Grid>
            </Dialog>
            <PreviewListaCidades />
        </>
    )
}